<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Sauvegarde de la conversation</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <app-folder-selector (folderSelected)="onSelected($event)"></app-folder-selector>

            <div class="form-item">
                <mat-form-field class="mat-form-field-title">
                    <mat-label>Intitulé</mat-label>
                    <input matInput [formControl]="titleFormControl" [(ngModel)]="data.title" placeholder="" autocomplete="off" />
                </mat-form-field>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="data" [disabled]="!data.folderId || !data.title">Enregistrer</button>
    </mat-card-actions>
</mat-card>
